<template>
  <div class="incorrect-item-cards-view">
    <ScrollView
      :data-items="model"
      :content="'content'"
      :automaticViewChange="false"
      :activeView="activeView"
      :key="scrollViewKey"
    >
      <template v-slot:content="{ props: viewProps }">
        <div
          v-if="type == VisitIncorrectItemType.Ingredient"
          class="incorrect-item-cards-view__item ingredient"
        >
          <div class="incorrect-item-cards-view__item-header">
            <span>
              {{ VisitIncorrectItemType[type] }} #{{
                model.indexOf(viewProps.item) + 1
              }}
            </span>
            <a
              v-if="model!.length > 1 && !disableModification"
              class="incorrect-item-cards-view__remove"
              @click="removeItem(model.indexOf(viewProps.item))"
              data-cy="item-tile-remove"
            >
              <font-awesome-icon
                class="remove-icon"
                icon="fa-solid fa-warning"
              />
              Delete
            </a>
          </div>
          <div class="incorrect-item-cards-view__item-control">
            <span>Incorrect/ Missing?</span>
            <div class="incorrect-item-cards-view__item-radio-wrapper">
              <RadioButton
                :name="`group-${type}-${model.indexOf(viewProps.item)}`"
                :value="true"
                :checked="viewProps.item.IsIncorrect == true"
                @change="(e) => handleChange(e, viewProps.item)"
                label="Incorrect"
                :disabled="disableModification"
              />
              <RadioButton
                :name="`group-${type}-${model.indexOf(viewProps.item)}`"
                :value="false"
                :checked="viewProps.item.IsIncorrect == false"
                @change="(e) => handleChange(e, viewProps.item)"
                label="Missing"
                :disabled="disableModification"
              />
            </div>
          </div>
          <div class="incorrect-item-cards-view__item-control">
            <label
              :for="`card-ingredient-name-${model.indexOf(viewProps.item)}`"
              >Ingredient Name</label
            >
            <input
              v-if="!disableModification"
              :id="`card-ingredient-name-${model.indexOf(viewProps.item)}`"
              type="text"
              v-model="viewProps.item.IngredientName"
            />
            <p v-else class="incorrect-item-cards-view__item-value">
              {{ viewProps.item.IngredientName }}
            </p>
          </div>
          <div class="incorrect-item-cards-view__item-control">
            <label :for="`card-source-${model.indexOf(viewProps.item)}`"
              >Source</label
            >
            <input
              v-if="!disableModification"
              :id="`card-source-${model.indexOf(viewProps.item)}`"
              type="text"
              v-model="viewProps.item.Source"
            />
            <p v-else class="incorrect-item-cards-view__item-value">
              {{ viewProps.item.Source }}
            </p>
          </div>
          <div class="incorrect-item-cards-view__item-control">
            <label
              :for="`card-certified-agency-${model.indexOf(viewProps.item)}`"
              >Cert. Agency</label
            >
            <input
              v-if="!disableModification"
              :id="`card-certified-agency-${model.indexOf(viewProps.item)}`"
              type="text"
              v-model="viewProps.item.CertifiedAgency"
            />
            <p v-else class="incorrect-item-cards-view__item-value">
              {{ viewProps.item.CertifiedAgency }}
            </p>
          </div>
          <div class="incorrect-item-cards-view__item-control">
            <label :for="`card-rmc-${model.indexOf(viewProps.item)}`"
              >RMC / Comments</label
            >
            <input
              v-if="!disableModification"
              :id="`card-rmc-${model.indexOf(viewProps.item)}`"
              type="text"
              v-model="viewProps.item.Comments"
            />
            <p v-else class="incorrect-item-cards-view__item-value">
              {{ viewProps.item.Comments }}
            </p>
          </div>
        </div>

        <div
          v-if="type == VisitIncorrectItemType.Product"
          class="incorrect-item-cards-view__item product"
        >
          <div class="incorrect-item-cards-view__item-header">
            <span>
              {{ VisitIncorrectItemType[type] }} #{{
                model.indexOf(viewProps.item) + 1
              }}
            </span>
            <a
              v-if="model!.length > 1 && !disableModification"
              class="incorrect-item-cards-view__remove"
              @click="removeItem(model.indexOf(viewProps.item))"
              data-cy="item-tile-remove"
            >
              <font-awesome-icon
                class="remove-icon"
                icon="fa-solid fa-warning"
              />
              Delete
            </a>
          </div>
          <div class="incorrect-item-cards-view__item-control">
            <span>Incorrect/ Missing?</span>
            <div class="incorrect-item-cards-view__item-radio-wrapper">
              <RadioButton
                :name="`group-${type}-${model.indexOf(viewProps.item)}`"
                :value="true"
                :checked="viewProps.item.IsIncorrect == true"
                @change="(e) => handleChange(e, viewProps.item)"
                label="Incorrect"
                :disabled="disableModification"
              />
              <RadioButton
                :name="`group-${type}-${model.indexOf(viewProps.item)}`"
                :value="false"
                :checked="viewProps.item.IsIncorrect == false"
                @change="(e) => handleChange(e, viewProps.item)"
                label="Missing"
                :disabled="disableModification"
              />
            </div>
          </div>
          <div class="incorrect-item-cards-view__item-control">
            <label :for="`card-brand-name-${model.indexOf(viewProps.item)}`"
              >Brand Name</label
            >
            <input
              v-if="!disableModification"
              :id="`card-brand-name-${model.indexOf(viewProps.item)}`"
              type="text"
              v-model="viewProps.item.BrandName"
            />
            <p v-else class="incorrect-item-cards-view__item-value">
              {{ viewProps.item.BrandName }}
            </p>
          </div>
          <div class="incorrect-item-cards-view__item-control">
            <label :for="`card-label-${model.indexOf(viewProps.item)}`"
              >Label</label
            >
            <input
              v-if="!disableModification"
              :id="`card-label-${model.indexOf(viewProps.item)}`"
              type="text"
              v-model="viewProps.item.Label"
            />
            <p v-else class="incorrect-item-cards-view__item-value">
              {{ viewProps.item.Label }}
            </p>
          </div>
          <div class="incorrect-item-cards-view__item-control">
            <label :for="`card-dpm-${model.indexOf(viewProps.item)}`"
              >D/P/M</label
            >
            <input
              v-if="!disableModification"
              :id="`card-dpm-${model.indexOf(viewProps.item)}`"
              type="text"
              v-model="viewProps.item.Dpm"
            />
            <p v-else class="incorrect-item-cards-view__item-value">
              {{ viewProps.item.Dpm }}
            </p>
          </div>
          <div class="incorrect-item-cards-view__item-control">
            <label :for="`card-comments-${model.indexOf(viewProps.item)}`"
              >Comments</label
            >
            <input
              v-if="!disableModification"
              :id="`card-comments-${model.indexOf(viewProps.item)}`"
              type="text"
              v-model="viewProps.item.Comments"
            />
            <p v-else class="incorrect-item-cards-view__item-value">
              {{ viewProps.item.Comments }}
            </p>
          </div>
        </div>
      </template>
    </ScrollView>

    <div class="incorrect-items-view__actions">
      <Button
        v-if="model!.length < itemLimit && !disableModification"
        themeColor="primary"
        type="button"
        @click="addItem"
      >
        <font-awesome-icon icon="plus" />
        <span>Add</span>
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watchEffect, type ModelRef } from "vue";
import { VisitIncorrectItemType } from "@/Domain/VisitIncorrectItemType";
import type { RadioButtonChangeEvent } from "@progress/kendo-vue-inputs";
import RadioButton from "@/shared/ui/inputs/RadioButton.vue";
import { Button } from "@progress/kendo-vue-buttons";
import type { InspectionIncorrectItem } from "@/Domain/InspectionIncorrectItem";
import type { InspectionIncorrectProduct } from "@/Domain/InspectionIncorrectProduct";
import type { InspectionIncorrectIngredient } from "@/Domain/InspectionIncorrectIngredient";
import { ScrollView } from "@progress/kendo-vue-scrollview";

const props = defineProps<{
  type: VisitIncorrectItemType;
  disableModification?: boolean;
  addDefaultItem?: boolean;
}>();

const model = defineModel<InspectionIncorrectItem[]>() as ModelRef<
  InspectionIncorrectItem[]
>;
const itemLimit = 7;

const scrollViewKey = ref(0);
const activeView = ref(1);

const addItem = function () {
  if (props.type == VisitIncorrectItemType.Product) {
    model.value!.push({
      IsIncorrect: true,
      Comments: "",
      BrandName: "",
      Label: "",
      Dpm: "",
    } as InspectionIncorrectProduct);
  } else {
    model.value!.push({
      IsIncorrect: true,
      Comments: "",
      IngredientName: "",
      Source: "",
      CertifiedAgency: "",
    } as InspectionIncorrectIngredient);
  }
  activeView.value = model.value.length;
  // Trigger a re-render to update the scrollview
  scrollViewKey.value++;
};

const removeItem = function (index: number) {
  if (model.value.length == 1) return;

  // If the last item is removed, set the active view to the previous item
  if (index + 1 === model.value.length) {
    activeView.value = index;
    // Trigger a re-render to update the scrollview
    scrollViewKey.value++;
  }
  model.value!.splice(index, 1);
};

const handleChange = function (
  e: RadioButtonChangeEvent,
  item: InspectionIncorrectItem
) {
  item.IsIncorrect = e.value;
};

if (model.value!.length === 0) {
  addItem();
}

watchEffect(() => {
  if (props.addDefaultItem && model.value.length === 0) addItem();
});
</script>

<style lang="scss" scoped>
.incorrect-item-cards-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 0.5rem;

  &__item {
    margin: 0 auto;
    max-width: 360px;
    background: #f9f9f9;
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    border-top: 7px solid #4a90e2;
    padding: 20px;
    background-color: white;
    box-shadow: 0 2px 8px rgbal(0, 0, 0, 0.26);

    &-header {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 1rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    &-control {
      display: flex;
      flex-direction: column;
      margin-bottom: 1rem;

      & > label,
      & > span {
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 0.5rem;
      }

      & > input[type="text"] {
        padding: 0.5rem;
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        font-size: 14px;
        margin-top: 0.5rem;
      }
    }

    &-value {
      text-wrap: wrap;
      word-wrap: break-word;
    }

    > * {
      flex: 1;
      min-width: 0px;
    }
  }

  &__item-radio-wrapper {
    display: flex;
    gap: 16px;
    justify-content: flex-start;
  }

  &__actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    padding: 0.5rem 0;
    margin-top: 1rem;
    gap: 16px;
  }

  &__remove {
    color: #dc3545;
    cursor: pointer;
    font-size: 14px;
  }

  .k-scrollview {
    height: 600px;
    width: 100%;
    border: unset;

    // &-view {
    //   display: flex;
    //   justify-content: center;
    // }
  }
}
</style>

<style lang="scss">
.k-scrollview-elements {
  .k-svg-icon > svg {
    background: black;
    border-radius: 12px;
  }
}
</style>
